module.exports = __webpack_public_path__ + "img/68.2.TN.c6f976c7.png";